export default __webpack_public_path__ + "static/media/nothingfound.f4fc45e8.gif";